import React, { useCallback, useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

import useNotification from 'notification'

import _ from 'lodash'

import { formatHorarioString } from 'util/string'

import EntitySearchInput from 'components/form/EntitySearch/EntitySearchInput'
import ButtonSelectEntity from 'components/ButtonSelectEntity'
import DefaultCrudForm from 'components/form/DefaultCrudForm'
import TabContainer from 'components/tabs/TabContainer'
import { useUrlQueryUid2Field } from 'components/form'
import FormContent from 'components/form/FormContent'
import TabPanel from 'components/tabs/TabPanel'
import FormRow from 'components/form/FormRow'
import DataTable from 'components/DataTable'

import DialogAgendar from './DialogAgendar'

import { fetchArray } from 'entity'
import InscricaoEntity from 'entity/Inscricao'
import Reuniao from 'entity/Reuniao'
import Rodada from 'entity/Rodada'

import { Delete as DeleteIcon, Edit, KeyboardReturn } from '@mui/icons-material'
import {
  Box,
  Button,
  CircularProgress,
  /*DialogContent, DialogTitle, Fab,*/
  IconButton,
  Typography
} from '@mui/material'

const txtProdutos = (produtos) => {
  let r = ""
  produtos?.forEach(p => {
    r += p.nome + "; "
  })
  return r
}

function TabAncora({
  showWarning,
  ancora,
  index,
  fornecedores,
  matchs,
  updateReuniao,
  temAgendamentoNoHorarioGlobal,
  getReuniaoAncora,
  getReunioes,
  rodada,
}) {

  const { reunioes, mesa } = ancora
  let { empresa: { produtosCompra } } = ancora
  produtosCompra = produtosCompra?.map(p => p.produto)

  const removeParticipante2 = (reuniao) => {
    // updateReuniao({ ...reuniao, inscricao2: null })
    updateReuniao({ ...reuniao, inscricao2UID: reuniao.inscricao2.uid })
  }

  const setParticipante2 = (reuniao, participante) => {
    updateReuniao({ ...reuniao, inscricao2: participante })
  }

  if (!mesa) {
    return <Box sx={{ display: "flex", justifyContent: "center", color: 'text.disabled' }}>

      <Typography variant='h6'>- ATRIBUA UMA MESA A ESTE ÂNCORA -</Typography>
    </Box>
  }

  return <Box>

    <Typography variant='h6'>{mesa?.name}</Typography>
    <Typography variant='caption'>Produtos Comprar: {txtProdutos(produtosCompra)}</Typography>
    <Typography variant='h6'>Matchs:</Typography>
    <DataTable idField={'uid'}
      rows={matchs || []}
      columns={[
        // { field: "empresa.nomeEmpresaCracha", headerName: "Participante", flex: 2 },
        {
          field: "empresa.nomeEmpresaCracha",
          headerName: "Participante", flex: 2,
          renderCellValue: (row) => <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography style={{ flex: 1, textAlign: 'initial' }}>{_.get(row, "empresa.nomeEmpresaCracha")}</Typography>
            <IconButton onClick={() => window.open("/#/inscricao?uid=" + row.uid, '_blank')}><Edit /></IconButton>
          </Box>,


        },
        {
          field: "empresa.Uid",
          headerName: "Num. Reuniões", flex: 1,
          renderCellValue: (row) => <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography style={{ flex: 1, textAlign: 'initial' }}>{getReunioes(_.get(row, "uid")).length}</Typography>

          </Box>,


        },
        {
          field: "empresa.produtosVenda", headerName: "Matchs Produtos", flex: 2,
          valueGetter: ({ row }) => {
            let aux = row.matchsProdutos.map(p => p.produto ? p.produto : p)
            let h = "(" + row.matchsProdutos.length + ") " + txtProdutos(aux);
            return h || "-"
          }
        },
        {
          field: "uid", headerName: "Horário da Reunião", flex: 2,
          valueGetter: ({ row }) => {
            let reuniao = getReuniaoAncora(ancora, row.uid)

            if (reuniao) {
              return reuniao.horariotxt
            }
            return '-'
          }
        },

        {
          field: "empresa.cnpj",
          headerName: "Ações", flex: 1,
          renderCellValue: (row) => <Box>
            <DialogAgendar
              getReuniao={getReuniaoAncora}
              getReunioes={getReunioes}
              temAgendamentoNoHorarioGlobal={temAgendamentoNoHorarioGlobal}
              showWarning={showWarning}
              reunioes={reunioes}
              updateReuniao={updateReuniao}
              participanteRow={row}
              participanteTab={ancora}
              setParticipante2={setParticipante2}
              removeParticipante2={removeParticipante2}
              mesa={rodada.mesas.find(m => m.uid === mesa.uid)}
            />
          </Box>,


        },

      ]}

      autoHeight
    />


    <Typography variant='h6'>Reuniões:</Typography>
    <DataTable idField={'index'}
      columns={[
        { field: "inscricao1.empresa.nomeEmpresaCracha", headerName: "Ancora", flex: 2 },
        { field: "mesa.name", headerName: "Mesa", flex: 1 },
        { field: "horariotxt", headerName: "Horário", flex: 1 },
        { field: "inscricao2.empresa.nomeEmpresaCracha", headerName: "Fornecedor", flex: 2 },
        {
          field: "index",
          headerName: "Ações", flex: 1,
          renderCellValue: (row) =>
            <Box>
              {row.inscricao2 ?
                <IconButton onClick={() => removeParticipante2(row)}><DeleteIcon /></IconButton>
                :
                <>
                  {mesa.horariosReserved?.findIndex(h => h?.horario === row.horario.horario) > -1 ?

                    <Typography>Reservado</Typography>
                    :



                    <ButtonSelectEntity
                      EntityClass={InscricaoEntity}

                      hideFilterColumns={["rodada.nome", "status"]}
                      defaultFilters={{ tipo: "FORNECEDOR" }}
                      extraQuery={(query) => {
                        query = query.where("rodada.uid", "==", ancora.rodada.uid)
                        query = query.where("status", "==", "INSCRITO")
                        query = query.where("statusEvento", "in", ["PRESENTE", "INSCRITO"])
                        return query;
                      }}
                      onSelect={(selected) => {
                        if (!getReuniaoAncora(ancora, selected.uid)) {
                          if (!temAgendamentoNoHorarioGlobal(selected.uid, row.horario.horario)) {
                            setParticipante2(row, selected)
                          } else {
                            showWarning("Este fornecedor já possui agendamento para este horário")
                          }
                        } else {
                          showWarning("Já existe reunião entre estas empresas.")
                        }
                      }}
                    />
                  }

                </>
              }
            </Box>,


        },

      ]}
      rows={reunioes}
      autoHeight
    />
  </Box>
}
function TabFlutuante({
  showWarning,
  flutuante,
  index,
  flutuantes,
  matchs,
  updateReuniao,
  temAgendamentoNoHorarioGlobal,
  getReunioes,
  rodada,
  getReuniaoFlutuante,
}) {
  const { reunioes } = flutuante
  let { empresa: { produtosVenda, produtosCompra } } = flutuante
  produtosVenda = produtosVenda?.map(p => p.produto)
  produtosCompra = produtosCompra?.map(p => p.produto)

  const removeParticipante1 = (reuniao) => {
    // updateReuniao({ ...reuniao, inscricao1: null })
    updateReuniao({ ...reuniao, inscricao1UID: reuniao.inscricao1.uid })
  }

  const setParticipante1 = (reuniao, participante) => {
    updateReuniao({ ...reuniao, inscricao1: participante })
  }

  return <Box>
    <Typography variant='caption'>Produtos Vender: {txtProdutos(produtosVenda)}</Typography>
    <br />
    <Typography variant='caption'>Produtos Comprar: {txtProdutos(produtosCompra)}</Typography>
    <Typography variant='h6'>Matchs:</Typography>

    <DataTable
      idField={'uid'}
      rows={matchs || []}
      columns={[
        {
          field: "empresa.nomeEmpresaCracha",
          headerName: "Participante",
          flex: 2,
          renderCellValue: (row) => <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography style={{ flex: 1, textAlign: 'initial' }}>
              {_.get(row, "empresa.nomeEmpresaCracha")} {_.get(row, "mesa.name") ? (` - ${_.get(row, "mesa.name")}`) : ''}
            </Typography>
            <IconButton onClick={() => window.open("/#/inscricao?uid=" + row.uid, '_blank')}><Edit /></IconButton>
          </Box>,
        },
        {
          field: "uid2", headerName: "Mesa", flex: 1,
          valueGetter: ({ row }) => {
            let reuniao = getReuniaoFlutuante(flutuante, row.uid)

            if (reuniao) {
              return reuniao.mesa?.name

            }
            return '-'
          }
        },
        {
          field: "empresa.Uid",
          headerName: "Num. Reuniões", flex: 1,
          renderCellValue: (row) => <Box style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography style={{ flex: 1, textAlign: 'initial' }}>{getReunioes(_.get(row, "uid"))?.length}</Typography>
          </Box>,
        },
        {
          field: "empresa.produtosVenda", headerName: "Matchs Produtos", flex: 2,
          valueGetter: ({ row }) => {
            let aux = row.matchsProdutos.map(p => p.produto ? p.produto : p)
            let h = "(" + row.matchsProdutos.length + ") " + txtProdutos(aux);
            return h || "-"
          }
        },
        {
          field: "uid", headerName: "Horário da Reunião", flex: 2,
          valueGetter: ({ row }) => {
            let reuniao = getReuniaoFlutuante(flutuante, row.uid)

            if (reuniao) {
              return reuniao.horariotxt
            }
            return '-'
          }
        },
        {
          field: "empresa.cnpj",
          headerName: "Ações", flex: 1,
          renderCellValue: (row) => {
            return <Box>
              <DialogAgendar
                getReuniao={getReuniaoFlutuante}
                getReunioes={getReunioes}
                temAgendamentoNoHorarioGlobal={temAgendamentoNoHorarioGlobal}
                showWarning={showWarning}
                reunioes={reunioes}
                updateReuniao={updateReuniao}
                participanteRow={row}
                participanteTab={flutuante}
                mesa={rodada.mesas.find(m => m.uid === row.mesa?.uid)}
                setParticipante2={setParticipante1}
                removeParticipante2={removeParticipante1}
              />
            </Box>
          },
        },
      ]}

      autoHeight
    />


    <Typography variant='h6'>Reuniões:</Typography>
    <DataTable idField={'index'}
      columns={[
        { field: "inscricao2.empresa.nomeEmpresaCracha", headerName: "Fornecedor", flex: 2 },
        { field: "mesa.name", headerName: "Mesa", flex: 1 },
        { field: "horariotxt", headerName: "Horário", flex: 1 },
        { field: "inscricao1.empresa.nomeEmpresaCracha", headerName: "Ancora", flex: 2 },
        {
          field: "index",
          headerName: "Ações", flex: 1,
          renderCellValue: (row) =>
            <Box>
              {/* {console.log('row', row)} */}
              {row.inscricao1 ?
                <IconButton onClick={() => {
                  removeParticipante1(row)
                }}
                >
                  <DeleteIcon />
                </IconButton>
                :
                <>
                  {/* TODO: MESAS RESERVADAS
                  {mesa.horariosReserved?.findIndex(h => h?.horario === row.horario.horario) > -1 ?
                    <Typography>Reservado</Typography>
                    : */}
                  <ButtonSelectEntity
                    EntityClass={InscricaoEntity}

                    hideFilterColumns={["rodada.nome", "status"]}
                    defaultFilters={{ tipo: "ÂNCORA" }}
                    extraQuery={(query) => {
                      query = query.where("rodada.uid", "==", flutuante.rodada.uid)
                      query = query.where("status", "==", "INSCRITO")
                      query = query.where("statusEvento", "in", ["PRESENTE", "INSCRITO"])
                      return query;
                    }}
                    onSelect={(selected) => {
                      let i = rodada.mesas.findIndex(m => m.index === selected.mesa.index)
                      let selectedMesa = rodada.mesas[i]
                      let selectedHorario = row.horario.horario
                      let isMesaReserved = selectedMesa.horariosReserved && selectedMesa.horariosReserved.findIndex(mesa => mesa.horario === selectedHorario) > -1 ? true : false

                      if (!isMesaReserved) {
                        if (!getReuniaoFlutuante(flutuante, selected.uid)) {
                          if (!temAgendamentoNoHorarioGlobal(selected.uid, row.horario.horario)) {
                            row.mesa = selected.mesa
                            row.inscricao1 = selected
                            setParticipante1(row, selected)
                          } else {
                            showWarning("Este âncora já possui agendamento para este horário")
                          }
                        } else {
                          showWarning("Já existe reunião entre estas empresas.")
                        }
                      } else {
                        showWarning("A mesa do âncora está reservada nesse horário")
                      }
                    }}
                  />
                  {/* } */}

                </>
              }
            </Box>,


        },

      ]}
      rows={reunioes}
      autoHeight
    />
  </Box>
}

function AssistenteAgendamentoReunioesInter(props) {
  const { showWarning } = useNotification();
  const navigate = useNavigate()
  useUrlQueryUid2Field('rodada', 'rodada', Rodada, props.form)

  const { rodada } = props.values

  const [ancoras, setAncoras] = useState([])
  const [flutuantes, setFlutuantes] = useState([])
  const [reunioesSalvas, setReunioesSalvas] = useState([])

  const [searchParams] = useSearchParams()
  const searchRodada = searchParams.get("rodada")

  const [tab, setTab] = useState(0)
  const [tabAncoras, setTabAncoras] = useState(0)
  const [tabFlutuantes, setTabFlutuantes] = useState(0)
  const [matchsAncoras, setMatchsAncoras] = useState([])
  const [matchsFlutuantes, setMatchsFlutuantes] = useState([])

  useEffect(() => {
    let matchsAncorasNew = {}
    let matchsFlutuantesNew = {}
    if (rodada) {
      if (rodada.tipoAncora === "Sem Ancora") {
        if (flutuantes) {

          flutuantes.forEach(f => {
            let produtosVendaA = f.empresa.produtosVenda

            let produtosCompraA = f.empresa.produtosCompra


            const uidprodutosVendaA = produtosVendaA?.map(f => f.uid)
            const uidprodutosCompraA = produtosCompraA?.map(f => f.uid)
            let newMatchs = []
            flutuantes.filter(a => a.statusEvento !== "AUSENTE" && a.statusEvento !== "SAIU").forEach(a => {
              const { produtosVenda, produtosCompra } = a.empresa

              let matchsProdutos = []
              for (let index = 0; index < produtosVenda?.length; index++) {
                const produto = produtosVenda[index];

                if (uidprodutosCompraA?.includes(produto.uid)) {
                  matchsProdutos.push(produto)
                }
              }

              for (let index = 0; index < produtosCompra?.length; index++) {
                const produto = produtosCompra[index];

                if (uidprodutosVendaA?.includes(produto.uid)) {
                  matchsProdutos.push(produto)
                }
              }
              
              if (matchsProdutos.length) {
                let newA = _.cloneDeep(a)
                newA.matchsProdutos = matchsProdutos
                newMatchs.push(newA)
              }
            })
            newMatchs.sort((a, b) => a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1)
            matchsFlutuantesNew[f.uid] = newMatchs
          })

          setMatchsAncoras(matchsAncorasNew)
          setMatchsFlutuantes(matchsFlutuantesNew)
        }
      } else {
        if (ancoras && flutuantes) {
          ancoras.forEach(a => {
            // console.log('rodada', rodada)
            let produtosComercializar = a.empresa.produtosCompra
            if (rodada.tipoAncora === "Vendedor") {
              produtosComercializar = a.empresa.produtosVenda
            }


            const uidProdutosComercializar = produtosComercializar?.map(p => p.uid)
            let newMatchs = []
            flutuantes.filter(f => f.statusEvento !== "AUSENTE" && f.statusEvento !== "SAIU").forEach(f => {
              const { produtosVenda, produtosCompra } = f.empresa
              let produtosComercializarF = produtosVenda
              if (rodada.tipoAncora === "Vendedor") {
                produtosComercializarF = produtosCompra
              }
              let matchsProdutos = []
              for (let index = 0; index < produtosComercializarF?.length; index++) {
                const produto = produtosComercializarF[index];

                if (uidProdutosComercializar?.includes(produto.uid)) {
                  matchsProdutos.push(produto)
                }
              }

              if (matchsProdutos.length) {
                let newF = _.cloneDeep(f)
                newF.matchsProdutos = matchsProdutos
                newMatchs.push(newF)
              }



            })
            newMatchs.sort((a, b) => a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1)
            matchsAncorasNew[a.uid] = newMatchs
          })

          flutuantes.forEach(f => {
            let produtosComercializar = f.empresa.produtosVenda
            if (rodada.tipoAncora === "Vendedor") {
              produtosComercializar = f.empresa.produtosCompra
            }

            const uidProdutosComercializar = produtosComercializar?.map(f => f.uid)
            let newMatchs = []
            ancoras.filter(a => a.statusEvento !== "AUSENTE" && a.statusEvento !== "SAIU").forEach(a => {
              const { produtosVenda, produtosCompra } = a.empresa
              let produtosComercializarA = produtosCompra
              if (rodada.tipoAncora === "Vendedor") {
                produtosComercializarA = produtosVenda
              }
              let matchsProdutos = []
              for (let index = 0; index < produtosComercializarA?.length; index++) {
                const produto = produtosComercializarA[index];

                if (uidProdutosComercializar?.includes(produto.uid)) {
                  matchsProdutos.push(produto)
                }
              }

              if (matchsProdutos.length) {
                let newA = _.cloneDeep(a)
                newA.matchsProdutos = matchsProdutos
                newMatchs.push(newA)
              }
            })
            newMatchs.sort((a, b) => a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1)
            matchsFlutuantesNew[f.uid] = newMatchs
          })

          setMatchsAncoras(matchsAncorasNew)
          setMatchsFlutuantes(matchsFlutuantesNew)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ancoras, flutuantes])

  const loadInscricao = useCallback(async () => {
    const horariosPossiveis = rodada ? rodada.possiveisReunioes : []
    const criaPreReuniaoAncora = (horario, ancora, index) => {
      return {
        index,
        horario,
        horariotxt: formatHorarioString(horario.horario),
        inscricao1: ancora,
        mesa: ancora.mesa,
        rodada: rodada,
        status: "ATIVO",
      }
    }
    const criaPreReuniaoFlutuante = (horario, flutuante, index) => {
      return {
        index,
        horario,
        horariotxt: formatHorarioString(horario.horario),
        inscricao2: flutuante,
        mesa: flutuante.mesa,
        rodada: rodada,
        status: "ATIVO",
      }
    }

    if (rodada && !ancoras.length) {
      let novasMesas = rodada.mesas || []
      let novasMesasUid = novasMesas.map(m => m.uid)
      let resultInscricoes = await fetchArray(InscricaoEntity.collection
        .where("rodada.uid", "==", rodada.uid)
        .where("status", "==", "INSCRITO").get())
      // let query2 = await InscricaoEntity.where("rodada.uid", "==", rodada.uid).where("status", "==", "INSCRITO")

      // let resultInscricoes = await fetchArray(query2.get());
      // setInscricoes(resultInscricoes);
      resultInscricoes.forEach(insc => {
        if (insc.mesa) {
          let index = novasMesasUid.indexOf(insc.mesa.uid)
          insc.mesa = novasMesas[index]
          // console.log('insc.mesa ', insc.mesa)
        }
      })
      console.log('loadInscricao setAncoras')
      let an = (resultInscricoes.filter(i => i.tipo === "ÂNCORA").map(ancora => { return { ...ancora, reunioes: horariosPossiveis.map((h, index) => { return criaPreReuniaoAncora(h, ancora, index) }) } }))
      an.sort((a, b) => a.empresa.nomeFantasia > b.empresa.nomeFantasia ? 1 : -1)
      setAncoras(an)
      setFlutuantes(resultInscricoes.filter(i => i.tipo === "FORNECEDOR").map(flutuante => { return { ...flutuante, reunioes: horariosPossiveis.map((h, index) => { return criaPreReuniaoFlutuante(h, flutuante, index) }) } }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rodada]);

  useEffect(() => {
    loadInscricao();
  }, [loadInscricao]);

  useEffect(() => {
    if (ancoras.length && reunioesSalvas) {
      let newAncoras = _.cloneDeep(ancoras)
      reunioesSalvas.forEach(r => {
        for (let index = 0; index < newAncoras.length; index++) {
          const a = newAncoras[index];
          if (a.uid === r.inscricao1.uid) {
            for (let i2 = 0; i2 < a.reunioes.length; i2++) {
              const ra = a.reunioes[i2];
              if (ra.horario.horario === r.horario.horario) {
                a.reunioes[i2] = { ...r, index: i2 }
              }
            }
          }
        }
      })
      setAncoras(newAncoras)
    }


    if (flutuantes.length && reunioesSalvas) {
      let newFlutuantes = _.cloneDeep(flutuantes)
      reunioesSalvas.forEach(r => {
        for (let index = 0; index < newFlutuantes.length; index++) {
          const f = newFlutuantes[index];
          if (f.uid === r.inscricao2.uid) {
            for (let j = 0; j < f.reunioes.length; j++) {
              const rf = f.reunioes[j];
              if (rf.horario.horario === r.horario.horario) {
                f.reunioes[j] = { ...r, index: j }
              }
            }
          }
        }
      })
      setFlutuantes(newFlutuantes)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reunioesSalvas])


  const getReunioesAncoras = (uidFornecedor, ancs) => {
    let ancsusar = ancs || ancoras
    let reunioesF = []
    for (let index = 0; index < ancsusar.length; index++) {
      const a = ancsusar[index];

      let agenda = getReuniaoAncora(a, uidFornecedor);
      if (agenda) {
        reunioesF.push(agenda)
      }
    }

    return reunioesF;
  }

  const getReunioesFlutuantes = (uidAncora, flus) => {
    let flussusar = flus || flutuantes
    let reunioesF = []
    for (let index = 0; index < flussusar.length; index++) {
      const f = flussusar[index]

      let agenda = getReuniaoFlutuante(f, uidAncora)
      if (agenda) {
        reunioesF.push(agenda)
      }
    }

    return reunioesF
  }

  const temAgendamentoNoHorarioGlobalAncora = (uidFornecedor, horario) => {
    return temAgendamentoNoHorarioAncora(ancoras, uidFornecedor, horario)
  }

  const temAgendamentoNoHorarioGlobalFlutuante = (uidAncora, horario) => {
    return temAgendamentoNoHorarioFlutuante(flutuantes, uidAncora, horario)
  }

  const temAgendamentoNoHorarioFlutuante = (flutuantes, uidAncora, horario) => {
    for (let i = 0; i < flutuantes.length; i++) {
      const f = flutuantes[i]

      let agenda = getReuniaoFlutuante(f, uidAncora)
      if (agenda && agenda.horario.horario === horario) {
        return true
      }
    }
    return false
  }

  const temAgendamentoNoHorarioAncora = (ancoras, uidFornecedor, horario) => {
    for (let i = 0; i < ancoras.length; i++) {
      const a = ancoras[i];

      // verificando se existe uma reunião entre esse flutuante e esse ancora
      let agenda = getReuniaoAncora(a, uidFornecedor);

      // verificando se essa reunião entre eles é no horário do card atual
      if (agenda && agenda.horario.horario === horario) {
        return true;
      }
    }
    return false;
  }

  const getReuniaoAncora = (ancora, uidFornecedor) => {
    for (let i = 0; i < ancora.reunioes.length; i++) {
      const r = ancora.reunioes[i]
      if (r.inscricao2 && r.inscricao2.uid === uidFornecedor) {
        return r
      }
    }

    let flu

    for (let i = 0; i < flutuantes.length; i++) {
      if (flutuantes[i].uid === uidFornecedor) {
        flu = flutuantes[i]
        break
      }
    }

    if (flu) {
      let reuniao
      for (let i = 0; i < flu.reunioes.length; i++) {
        let r = flu.reunioes[i]
        if ((r.inscricao1 && r.inscricao1.uid === ancora.uid)
          || (r.inscricao2 && r.inscricao2.uid === ancora.uid)
        ) {
          reuniao = r
        }
      }
      if (reuniao) {
        // console.log('reuniao.horariotxt', reuniao.horariotxt)
        return reuniao
      }
    }

    return null
  }

  // buscando as reuniões do flutuante e do ancora p/ saber se o horário ta livre p/ os dois
  const getReuniaoFlutuante = (flutuante, uidAncora) => {
    for (let i = 0; i < flutuante.reunioes.length; i++) {
      const r = flutuante.reunioes[i]

      // esse ancora e esse flutuante ja tem uma reunião marcada
      if (r.inscricao1 && r.inscricao1.uid === uidAncora) {
        // console.log('r', r)
        return r
      }
    }

    let anc

    for (let i = 0; i < ancoras.length; i++) {
      if (ancoras[i].uid === uidAncora) {
        anc = ancoras[i]
        break
      }
    }

    if (anc) {
      let reuniao
      for (let i = 0; i < anc.reunioes.length; i++) {
        let r = anc.reunioes[i]
        if ((r.inscricao1 && r.inscricao1.uid === flutuante.uid)
          || (r.inscricao2 && r.inscricao2.uid === flutuante.uid)
        ) {
          reuniao = r
        }
      }
      if (reuniao) {
        // console.log('reuniao.horariotxt', reuniao.horariotxt)
        return reuniao
      }
    }

    return null
  }

  const getAgendasDiponiveis = (ancora) => {
    return ancora.reunioes.filter(r => {
      if (ancora.mesa?.horariosReserved) {
        if (ancora.mesa.horariosReserved.find(h => h.horario === r.horario.horario)) {
          return false
        }
      }

      return !r.inscricao2
    })
    // return ancora.reunioes.filter(r => !r.inscricao2)
  }
  const gerar = () => {
    console.log('gerar', ancoras, flutuantes)
    const ordenaPriorizaFornecedor = (list, newAncoras) => {
      let r = []
      list.forEach(forn => {
        r.push({ forn, numReuniao: getReunioesAncoras(forn.uid, newAncoras).length })

      })
      r.sort((a, b) => {
        return a.numReuniao - b.numReuniao
      })

      return r

    }
    if (ancoras && flutuantes) {
      for (let index = 0; index < ancoras.length; index++) {
        const a = ancoras[index];
        if (!a.mesa) {
          showWarning("Todos os ancoras devem ter mesas atribuidas!")
          return

        }

      }
      let newAncoras = _.cloneDeep(ancoras)
      newAncoras.forEach(a => {
        let fmatch = matchsAncoras[a.uid];
        let listFor = ordenaPriorizaFornecedor(fmatch, newAncoras)
        listFor.forEach(rforn => {
          let reuniaoExistente = getReuniaoAncora(a, rforn.forn.uid);
          if (!reuniaoExistente) {
            let agendasDisponiveis = getAgendasDiponiveis(a);
            // console.log('agendasDisponiveis',agendasDisponiveis)
            for (let index = 0; index < agendasDisponiveis.length; index++) {
              const agenda = agendasDisponiveis[index];
              if (!temAgendamentoNoHorarioAncora(newAncoras, rforn.forn.uid, agenda.horario.horario)) {
                agenda.inscricao2 = rforn.forn
                break;
              }

            }

          }
        })

      })
      let newFlutuantes = _.cloneDeep(flutuantes)
      console.log('newFlutuantes',newFlutuantes)
      console.log('matchsFlutuantes',matchsFlutuantes)
      newFlutuantes.forEach(f => {
        let fmatch = matchsFlutuantes[f.uid];
        let listFor = ordenaPriorizaFornecedor(fmatch, newFlutuantes)
        console.log('fmatch listFor',listFor)
        listFor.forEach(rforn => {
          let reuniaoExistente = getReuniaoAncora(f, rforn.forn.uid);
          if (!reuniaoExistente) {
            let agendasDisponiveis = getAgendasDiponiveis(f);
            // console.log('agendasDisponiveis',agendasDisponiveis)
            for (let index = 0; index < agendasDisponiveis.length; index++) {
              const agenda = agendasDisponiveis[index];
              if (!temAgendamentoNoHorarioAncora(newAncoras, rforn.forn.uid, agenda.horario.horario)) {
                agenda.inscricao2 = rforn.forn
                break;
              }

            }

          }
        })

      })
      console.log('gerou')
      setAncoras(newAncoras)

    }


  }
  useEffect(() => {
    let observer = null;
    if (rodada && ancoras.length) {

      observer = Reuniao.collection
        .where("rodada.uid", "==", rodada.uid)
        .where("status", "==", "ATIVO")
        .onSnapshot(snap => {
          let data = []
          snap.forEach((doc) => {
            data.push(doc.data());
          });
          data.sort((a, b) => {
            let aH = a.horariotxt.split("-").reverse().join("");
            let bH = b.horariotxt.split("-").reverse().join("");
            return aH > bH ? 1 : -1
          })
          setReunioesSalvas(data);
        })
    }
    return () => {
      if (observer) observer()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ancoras.length])
  const extraQueryRodada = (query) => {
    query = query.where("status", "==", "ATIVO")
    return query;
  }
  const updateReuniaoAncora = (reuniao) => {
    let newFlutuantes = _.cloneDeep(flutuantes)
    let indexInsc2 = newFlutuantes.map(f => f.uid).indexOf(reuniao.inscricao2.uid)
    let flu = newFlutuantes[indexInsc2]

    let newAncoras = _.cloneDeep(ancoras)
    let indexInsc1 = newAncoras.map(a => a.uid).indexOf(reuniao.inscricao1.uid)
    let anc = newAncoras[indexInsc1]

    // remove flutuante
    if (typeof reuniao?.inscricao2UID === 'string') {
      let { inscricao1UID, inscricao2UID, ...reuniaoNoUids } = reuniao
      let { inscricao2, ...newReuniaoAncora } = reuniaoNoUids
      let { inscricao1, mesa, ...newReuniaoFlutuante } = reuniaoNoUids

      anc.reunioes[reuniao.index] = newReuniaoAncora
      flu.reunioes[reuniao.index] = newReuniaoFlutuante

      setFlutuantes(newFlutuantes)
      console.log("Reunião removida...")
    }
    // apenas atualiza reunião
    else {
      flu.reunioes[reuniao.index] = reuniao
      anc.reunioes[reuniao.index] = reuniao

      newFlutuantes[indexInsc2].reunioes[reuniao.index] = reuniao
      newAncoras[indexInsc1].reunioes[reuniao.index] = reuniao

      setFlutuantes(newFlutuantes)

      console.log("Reunião atualizada...")
    }

    setAncoras(newAncoras)
  }

  const updateReuniaoFlutuante = (reuniao) => {
    let newFlutuantes = _.cloneDeep(flutuantes)
    let indexInsc2 = newFlutuantes.map(f => f.uid).indexOf(reuniao.inscricao2.uid)
    let flu = newFlutuantes[indexInsc2]

// <<<<<<< HEAD (b_2002)
    let newAncoras = _.cloneDeep(ancoras)
    let indexInsc1 = newAncoras.map(a => a.uid).indexOf(reuniao.inscricao1.uid)
    let anc = newAncoras[indexInsc1]

    // remove âncora
    // if (typeof reuniao?.inscricao1UID === 'string') {
      // let { inscricao1UID, inscricao2UID, ...reuniaoNoUids } = reuniao
      // let { inscricao2, ...newReuniaoAncora } = reuniaoNoUids
      // let { inscricao1, mesa, ...newReuniaoFlutuante } = reuniaoNoUids

      // anc.reunioes[reuniao.index] = newReuniaoAncora
      // flu.reunioes[reuniao.index] = newReuniaoFlutuante

      // setAncoras(newAncoras)

// =======
    if (typeof reuniao.inscricao1UID === 'string') {
      let newAncoras = _.cloneDeep(ancoras)
      let anc = newAncoras[newAncoras.map(a => a.uid).indexOf(reuniao.inscricao1UID)]
      if (anc)
        anc.reunioes[reuniao.index] = { ...reuniao, inscricao2: null }
      flu.reunioes[reuniao.index] = { ...reuniao, inscricao1: null, mesa: null }

      if (anc)
        setAncoras(newAncoras)
// >>>>>>> main
      console.log("Reunião removida...")
    }
    // apenas atualiza reunião
    else {
      flu.reunioes[reuniao.index] = reuniao
      anc.reunioes[reuniao.index] = reuniao

      newFlutuantes[indexInsc2].reunioes[reuniao.index] = reuniao
      newAncoras[indexInsc1].reunioes[reuniao.index] = reuniao

      setAncoras(newAncoras)

      console.log("Reunião atualizada...")
    }

    setFlutuantes(newFlutuantes)
  }

  const salvarReunioes = () => {
    ancoras.forEach(a => {
      a.reunioes.forEach(reuniao => {
        if (reuniao.inscricao2 || reuniao.uid) {
          console.log('salvarReuniao ancora', reuniao)
          if (reuniao.uid && !reuniao.inscricao2) {
            let entity = new Reuniao()
            entity.update({ uid: reuniao.uid, status: 'INATIVO' });

            entity.save().then(() => {
              console.log('salvou reuniao ancora')


            })
          } else {

            let entity = new Reuniao()
            entity.update(reuniao);

            entity.save().then(() => {
              console.log('salvou reuniao ancora')
            })
          }
        }
      });
    });

    // essa tela só salva reuniões entre flutuantes e ancoras, então basta salvar as reuniões dos ancoras
    // pois caso contrário as reuniões são salvas duplicadas
    // flutuantes.forEach(f => {
    //   f.reunioes.forEach(r => {
    //     if (r.inscricao1 || r.uid) {
    //       console.log('salvarReuniao flutuante', r)
    //       if (r.uid && !r.inscricao1) {
    //         let entity = new Reuniao()

    //         entity.update({ uid: r.uid, status: 'INATIVO' })

    //         entity.save().then(() => {
    //           console.log('salvou reuniao flutuante')
    //         })
    //       } else {

    //         let entity = new Reuniao()
    //         entity.update({ ...r, mesa: r.inscricao1.mesa })

    //         entity.save().then(() => {
    //           console.log('salvou reuniao flutuante')
    //         })
    //       }
    //     }
    //   })
    // })
    navigate("/painel-controle?rodada=" + rodada.uid)
  }

  return (
    <>
      {searchRodada &&
        <Button
          startIcon={<KeyboardReturn />}
          variant='contained'
          color='primary'
          onClick={() => {
            // console.log(`${window.location.origin}/#/painel-controle?rodada=${searchRodada}`)
            // navigator.clipboard.writeText(`${window.location.origin}/#/painel-controle?rodada=${searchRodada}`)
            navigate(`/painel-controle?rodada=${searchRodada}`)
          }}
        >
          Retornar ao painel de controle
        </Button>
      }
      <FormContent sx={{ m: 1 }}>
        <FormRow>
          <EntitySearchInput
            name="rodada"
            label="Rodada"
            EntityClass={Rodada}
            extraQuery={extraQueryRodada}
            disabled={rodada ? true : false}
            required
          />
          <Button disabled={rodada ? false : true} onClick={gerar} >Gerar Agendamentos</Button>
          <Button disabled={rodada ? false : true} onClick={salvarReunioes} >Salvar Reuniões</Button>
        </FormRow>
        {rodada ? <>
          <TabContainer tab={tab} changeTab={setTab}
            tabsProps={{
              TabIndicatorProps: { sx: { display: 'none' } },
              sx: {
                '& .MuiTabs-flexContainer': {
                  flexWrap: 'wrap',
                },
                "& .MuiButtonBase-root-MuiTab-root": {
                  backgroudColor: "#f00"
                }
              }
            }}
          >
            {rodada.tipoAncora !== "Sem Ancora" &&
              <TabPanel label={`Ancoras: ${ancoras.filter(a => a.statusEvento !== "SAIU" && a.statusEvento !== "AUSENTE").length}`} sx={{ m: 1 }}>
                {(ancoras.length) ?
                  <TabContainer tab={tabAncoras} changeTab={setTabAncoras}
                    tabsProps={{
                      TabIndicatorProps: { sx: { display: 'none' } },
                      sx: { '& .MuiTabs-flexContainer': { flexWrap: 'wrap', }, "& .MuiButtonBase-root-MuiTab-root": { backgroudColor: "#f00" } }
                    }}
                  >
                    {ancoras.filter(i => i.statusEvento !== "AUSENTE" && i.statusEvento !== "SAIU").map((a, index) => (
                      <TabPanel key={index} label={a.empresa.nomeEmpresaCracha} sx={{ m: 1 }}>
                        <TabAncora
                          showWarning={showWarning}
                          ancora={a}
                          index={index}
                          updateReuniao={updateReuniaoAncora}
                          getReunioes={getReunioesAncoras}
                          fornecedores={flutuantes}
                          matchs={matchsAncoras[a.uid]}
                          temAgendamentoNoHorarioGlobal={temAgendamentoNoHorarioGlobalAncora}
                          getReuniaoAncora={getReuniaoAncora}
                          rodada={rodada}
                        />
                      </TabPanel>
                    ))}
                  </TabContainer>
                  : <Box sx={{ display: 'flex', flex: 1, justifyContent: "center" }} ><CircularProgress /></Box>
                }
              </TabPanel>
            }
            <TabPanel label={(rodada.tipoAncora === "Sem Ancora" ? "Participantes" : "Fluantes") + `: ${flutuantes.filter(a => a.statusEvento !== "SAIU" && a.statusEvento !== "AUSENTE").length}`} sx={{ m: 1 }}>
              {(flutuantes.length)
                ? (
                  <TabContainer tab={tabFlutuantes} changeTab={setTabFlutuantes}
                    tabsProps={{
                      TabIndicatorProps: { sx: { display: 'none' } },
                      sx: { '& .MuiTabs-flexContainer': { flexWrap: 'wrap', }, "& .MuiButtonBase-root-MuiTab-root": { backgroudColor: "#f00" } }
                    }}
                  >
                    {flutuantes.filter(i => i.statusEvento !== "AUSENTE" && i.statusEvento !== "SAIU").map((f, index) => (
                      <TabPanel key={index} label={f.empresa.nomeEmpresaCracha} sx={{ m: 1 }}>
                        <TabFlutuante
                          showWarning={showWarning}
                          flutuante={f}
                          index={index}
                          flutuantes={flutuantes}
                          matchs={matchsFlutuantes[f.uid]}
                          rodada={rodada}
                          updateReuniao={updateReuniaoFlutuante}
                          getReunioes={getReunioesFlutuantes}
                          temAgendamentoNoHorarioGlobal={temAgendamentoNoHorarioGlobalFlutuante}
                          getReuniaoFlutuante={getReuniaoFlutuante}
                        />
                      </TabPanel>
                    ))}
                  </TabContainer>
                )
                : <Box sx={{ display: 'flex', flex: 1, justifyContent: "center" }} ><CircularProgress /></Box>
              }
            </TabPanel>
          </TabContainer>
        </> : <Box sx={{ display: 'flex', flex: 1, justifyContent: "center", color: 'text.disabled' }} ><Typography variant='h6'>- SELECIONE UMA RODADA -</Typography></Box>}
      </FormContent>
    </>
  )
}


export default function AssistenteAgendamentoReunioes(props) {
  return (
    <DefaultCrudForm title={"Assistente de Agendamento de Reuniões"}
      formActions={{ novoForm: false, salvarForm: false, sairForm: false }}>
      {(props) => {
        return <AssistenteAgendamentoReunioesInter {...props} />
      }}
    </DefaultCrudForm>
  )

}


